module.exports = __webpack_public_path__ + "45ee9bf843ebaf32570a30c40264d87d.fbx";